// Da dove sei nel markdown a cosa cercare nel PDF.
//
// Non esiste una mappa riga→pagina: pandoc scrive LaTeX e xelatex impagina, e
// nessuno dei due ci riporta indietro le righe del markdown. Però il PDF il suo
// testo ce l'ha, ed è lo stesso testo che hai sotto il cursore. Quindi
// l'ancoraggio è una FRASE: si prende quella dove sei, la si ripulisce dalla
// sintassi che nel PDF non compare (i cancelletti, gli asterischi, i §, i
// pipe), e la si cerca nel documento composto.
//
// Ne discende un limite, che è meglio dire che nascondere: una riga fatta solo
// di sintassi (una riga vuota, un `---`, una direttiva META) non ancora niente
// — allora si cerca la riga di testo più vicina, sopra o sotto.

const RUMORE: [RegExp, string][] = [
    [/`{1,3}[^`]*`{1,3}/g, " "],           // codice: nel PDF c'è, ma cambia forma
    [/<\?[\s\S]*?\?>/g, " "],              // direttive e commenti
    [/!?\[([^\]]*)\]\([^)]*\)/g, "$1"],    // link e immagini: resta l'etichetta
    [/\[([^\]]*)\]\{[^}]*\}/g, "$1"],      // span attribuiti (il sottolineato)
    [/§[A-Za-z][A-Za-z0-9_.:-]*/g, " "],   // ancore e citazioni
    [/[*_~]+/g, " "],                      // marcature
    [/^\s{0,3}#{1,6}\s+/g, " "],           // cancelletti del titolo
    [/^\s*[-*+]\s+/g, " "],                // punti elenco
    [/^\s*>\s?/g, " "],                    // citazioni a blocco
    [/\|/g, " "],                          // bordi di tabella
];


function ripulisci(riga: string): string
{
    let t = riga;

    for (const [cosa, con] of RUMORE) { t = t.replace(cosa, con); }

    return t.replace(/\s+/g, " ").trim();
}


/** Quanto testo vero serve perché una riga valga come àncora. */
const MINIMO = 12;


export function fraseDaCursore(testo: string, offset: number): string | null
{
    const righe = testo.split("\n");

    // La riga del cursore, contata sugli offset.
    let riga = 0;
    let visti = 0;

    while (riga < righe.length && visti + (righe[riga] ?? "").length + 1 <= offset)
    {
        visti += (righe[riga] ?? "").length + 1;
        riga++;
    }

    // Dalla riga del cursore in fuori, alternando sotto e sopra: la frase più
    // vicina è quella che descrive meglio dove stai guardando.
    for (let d = 0; d < righe.length; d++)
    {
        for (const candidata of d === 0 ? [riga] : [riga + d, riga - d])
        {
            if (candidata < 0 || candidata >= righe.length) { continue; }

            const pulita = ripulisci(righe[candidata] ?? "");

            // Le righe di separazione delle tabelle diventano una fila di
            // trattini: pulite sembrano testo, ma nel PDF non esistono.
            if (pulita.length >= MINIMO && /[A-Za-zÀ-ÿ0-9]{3}/.test(pulita) && !/^[-:\s]+$/.test(pulita))
            {
                // Una manciata di parole basta a distinguere il punto, e più
                // corta è più regge le sillabazioni e gli a capo del PDF.
                return pulita.split(" ").slice(0, 8).join(" ");
            }
        }
    }

    return null;
}


/** La forma in cui si confrontano markdown e PDF: spazi normalizzati, minuscolo. */
export function normalizza(testo: string): string
{
    return testo.toLowerCase().replace(/[­‐-―]/g, "-").replace(/\s+/g, " ").trim();
}
